import { useMemo } from "react";

import { isOptionArray, Option } from "api/common/types/common.types";

// Utility to turn an array of strings into an array of options
export const createOptionsFromStrings = (strings: string[]): Option[] => {
  return strings.map((s) => ({
    value: s,
    label: s,
  }));
};

// Utility to normalize options and turn them into an array of options
export const useNormalizedOptions = (options: string[] | Option[]) => {
  const normalizedOptions = useMemo(() => {
    return isOptionArray(options) ? options : createOptionsFromStrings(options);
  }, [options]);

  return normalizedOptions;
};
